import { render, staticRenderFns } from "./ModulesReworkStudentWrapper.vue?vue&type=template&id=22e5ce77"
import script from "./ModulesReworkStudentWrapper.vue?vue&type=script&lang=js"
export * from "./ModulesReworkStudentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports